<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="title"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
    >
        <div>
            <b-row>
                <b-col md="12">
                    <MdEdit
                        v-bind:Label="$t('Shared.UserName')"
                        v-bind:Name="'UserId'"
                        v-bind:MaxLengthProp="45"
                        v-model="userName"
                        v-bind:isReadOnly="false"
                        v-bind:Id="'UserId'"
                        v-bind:TypeProp="'text'"
                        v-bind:isValid="isUserNameValid"
                        v-bind:isRequired="true"
                    >
                    </MdEdit>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <MdPassword
                        v-bind:Label="$t('Shared.NewPassword')"
                        v-bind:TypeProp="'password'"
                        v-bind:Name="'newPassword'"
                        v-bind:MaxLengthProp="45"
                        ref="inputnewpassword"
                        v-bind:TabIndex="'2'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isNewPasswordValid"
                        v-bind:isEndControl="false"
                        v-model="newPassword"
                        v-bind:Autocomplete="false"
                    >
                    </MdPassword>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <MdPassword
                        v-bind:Label="$t('Shared.ConfirmPass')"
                        v-bind:TypeProp="'password'"
                        v-bind:Name="'confirmPassword'"
                        v-bind:MaxLengthProp="45"
                        ref="inputconfirmpassword"
                        v-bind:TabIndex="'3'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isConfirmPasswordValid"
                        v-bind:isEndControl="true"
                        v-model="confirmPassword"
                        :EndControlFunction="EndFunction"
                        v-bind:Autocomplete="false"
                    >
                    </MdPassword>
                </b-col>
            </b-row>
        </div>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import PatientPortalsService from '@/services/patientportals.service';

export default {
    name: 'PatientPortalCreateLogin',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        patientCode: {
            type: String,
            required: true
        },
        fullName: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalCreateLoginModal',
            emitCloseEvent: false,
            newPassword: '',
            isNewPasswordValid: true,
            confirmPassword: '',
            isConfirmPasswordValid: true,
            userName: '',
            isUserNameValid: true
        };
    },
    computed: {
        title() {
            return `${this.$t('PatientPortalDashboard.RightBar.CreateLogin')}: ${
                this.patientCode
            } - ${this.fullName}`;
        }
    },
    methods: {
        resetData() {
            this.newPassword = '';
            this.isNewPasswordValid = true;
            this.confirmPassword = '';
            this.isConfirmPasswordValid = true;
            this.userName = '';
            this.isUserNameValid = true;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                this.changePassword();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate_required() {
            this.isNewPasswordValid = this.newPassword.length > 0 ? true : false;
            this.isConfirmPasswordValid = this.confirmPassword.length > 0 ? true : false;
            this.isUserNameValid = this.userName.length > 0 ? true : false;
            return this.isNewPasswordValid && this.isConfirmPasswordValid && this.isUserNameValid;
        },

        EndFunction() {
            this.changePassword();
        },

        changePassword() {
            if (this.comparePassword()) {
                PatientPortalsService.createLogin({
                    userName: this.userName,
                    password: this.newPassword,
                    email: this.email,
                    patientCode: this.patientCode
                })
                    .then(response => {
                        if (response.status == '200') {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.CreatedLoginMessage')
                            );

                            this.$nextTick(() => {
                                this.$emit('update:visible', false);
                                this.resetData();

                                if (response.data) {
                                    this.$emit('ok', response.data);
                                }
                            });
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Shared.DontMatch'),
                    'error'
                );
            }
        },

        comparePassword() {
            if (this.newPassword === this.confirmPassword) {
                return true;
            }
            return false;
        }
    }
};
</script>
